<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">

    <section class="border border-gray-800 p-3">
        <div class="flex justify-between">
            <h4 class="text-white text-sm font-bold uppercase mb-3">Create {{ featureName }} feature</h4>
            <span v-if="$page.props.errors" v-for="err in Object.values($page.props.errors)" class="errormessage font-bold">{{ err }}</span>
            <button type="button" class="close" @click.prevent="closeModalAndClearTheForm">
              <span>&times;</span>
            </button>
        </div>
    </section>

    <div class="flex lang-box mt-5">
        <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
        :class="{active:(form.current_language == lang)}">{{ showFallbackLang(lang) }}</a>
    </div>

    <section class="border border-gray-800 p-3">
        <h5 class="text-white text-lg font-bold uppercase mb-3">Information</h5>
    </section>

    <section class="border border-gray-800 p-3">
        <h5 class="text-white text-lg font-bold uppercase mb-3">Text</h5>

        <label for="headline">Headline</label>
        <input class="input-black" type="text" id="headline" v-model="form.headline[form.current_language]">

        <label for="headline">Text</label>
        <textarea class="input-black" rows="10" v-model="form.text[form.current_language]"></textarea>
    </section>

    <section class="border border-gray-800 p-3">
        <div class="block text-center">
            <button v-if="!form.processing" class="btn btn-gradient" @click="saveFeature"><i class="save mr-1"></i>Save</button>
            <button v-else class="btn btn-gradient"><Spinner/></button>
        </div>
    </section>

    </div>
  </div>
</div>
</template>

<script>
import { showFallbackLang } from '@/Pages/GlobalHelpers';
import Spinner from '@/UI/Spinner';

export default {
    components: {
        Spinner,
    },
    props: ['showModal', 'closeModal', 'featureName', 'changeUploadBoxState', 'form'],
    data(){
        return {
            languages: this.$page.props.tour.data.languages,
        }
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
    },
    methods: {
        saveFeature() {
            this.form.post(route('textfeature.store', this.$page.props.station.data.id), {
              preserveScroll: true,
              onSuccess: () => this.closeModalAndClearTheForm(),
            });
        },
        changeLanguage(lang){
            this.form.current_language = lang;
        },
        showFallbackLang:showFallbackLang,
        closeModalAndClearTheForm(){
            this.form.headline = this.generateLanguagesForTextFields();
            this.form.text = this.generateLanguagesForTextFields();
            this.closeModal();
        },
        generateLanguagesForTextFields(){
            let obj = {};
            this.$page.props.tour.data.languages.forEach(el => {
                obj[el] = '';
            })
            return obj;
        },
    },
}
</script>
